<template>
  <div class="member-vip-list">
    <div class="member-vip" v-for="vip in vipConfigs" :key="vip.type" v-show="vipType.type === vip.type">
      <div class="recommend-tag" v-if="isRecommend.includes('recommend')">推荐</div>
      <div class="top-box">
        <h4>{{ vip.title }}</h4>
        <div class="member-vip-panel">
          <strong :class="vip.originalPrice ? 'price-shift-left' : ''">
            <span class="price">{{ vip.price }}</span>
            <span class="price-unit">{{ vip.unit }}</span>
            <span v-if="vip.originalPrice" class="original-price">{{ vip.originalPrice }}</span>
          </strong>
          <p class="desc">{{ vip.description }}</p>
          <button class="upgrade-btn upgrade-plus" @click="getVip(vip.type)">立即开通</button>
        </div>
      </div>
      <div class="bottom-box">
        <div>
          <h5><i class="icon el-icon-document-copy"></i><span>内容服务</span></h5>
          <div class="box_item">
            <span class="item_txt" style="width: 70%;text-align: left;">免费和VIP试卷</span>
            <b class="item_select">{{ vip.dailyLimit }}</b>
          </div>
          <div class="box_item">
            <span class="item_txt">有效期</span>
            <b class="item_select">{{ vip.period }}</b>
          </div>
          <div class="box_item">
            <span class="item_txt">题库答题</span>
            <b class="primary-color6 item_select">无限次</b>
          </div>
          <div class="box_item">
            <span class="item_txt">查看试题答案/解析</span>
            <b class="primary-color6 item_select">无限次</b>
          </div>
        </div>
        <div>
          <h5><img src="@/assets/vip.svg"><span>尊享服务</span></h5>
          <div v-for="service in vip.services" :key="service.name" class="box_item">
            <span class="item_txt">{{ service.name }}</span>
            <b :class="service.enabled ? 'el-icon-check icon-right' : 'el-icon-close icon-right'"></b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  openVip,
  getUserTypeList
} from "@/api/index.js"

// 静态缓存，防止重复请求
const priceCache = {
  student: {
    loading: false,
    data: null,
    promise: null
  }
}

export default {
  filters: {
    formatType(type) {
      switch (type) {
        case 1:
          return "会员"
          break;
        case 2:
          return "会员"
          break;
        case 3:
          return "会员-周"
          break;
        case 4:
          return "会员-月"
          break;
        case 5:
          return "会员-年"
          break;
        case 6:
          return "会员-3年"
          break;
        case 7:
          return "会员-3月"
          break;
        default:
          break;
      }
    }
  },
  props: {
    isRecommend: {
      type: String,
      default: 'selfVipCard'
    },
    vipType: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      userVipType: null,
      userId: 1,
      value: '1',
      vipConfigs: [
        {
          type: 4,
          title: '月会员',
          price: '49',
          unit: '元/月',
          originalPrice: '99元/月',
          description: '全站试题免费作答，试卷每日15次免费作答',
          dailyLimit: '15次/天/账号',
          period: '30天',
          services: [
            { name: 'VIP专享文档', enabled: true },
            { name: '试卷下载', enabled: false },
            { name: '精品专辑', enabled: false },
            { name: '专员录题/组卷', enabled: false }
          ]
        },
        {
          type: 7,
          title: '季度会员',
          // 99
          price: '129',
          unit: '元/季',
          originalPrice: '199元/季',
          description: '全站试题免费作答，试卷每日20次免费作答',
          dailyLimit: '20次/天/账号',
          period: '95天',
          services: [
            { name: 'VIP专享文档', enabled: true },
            { name: '试卷下载', enabled: true },
            { name: '精品专辑', enabled: true },
            { name: '专员录题/组卷', enabled: false }
          ]
        },
        {
          type: 5,
          title: 'PLUS年会员',
          // 229
          price: '269',
          unit: '元/年',
          originalPrice: '399元/年',
          description: '全站试题免费作答，试卷每日30次免费作答',
          dailyLimit: '30次/天/账号',
          period: '一年',
          services: [
            { name: 'VIP专享文档', enabled: true },
            { name: '试卷下载', enabled: true },
            { name: '精品专辑', enabled: true },
            { name: '专员录题/组卷', enabled: true }
          ]
        },
        {
          type: 1,
          title: '尊享永久会员',
          price: '2999',
          unit: '元/永久',
          description: '全站试题免费作答，试卷每日30次免费作答',
          dailyLimit: '30次/天/账号',
          period: '永久有效',
          services: [
            { name: 'VIP专享文档', enabled: true },
            { name: '试卷下载', enabled: true },
            { name: '精品专辑', enabled: true },
            { name: '专员录题/组卷', enabled: true }
          ]
        }
      ]
    }
  },
  mounted() {
    this.userVipType = this.vipType.type
    this.userId = localStorage.getItem("userId")
    this.fetchVipPrices()
  },
  methods: {
    // 获取会员价格
    fetchVipPrices() {
      const cache = priceCache.student
      
      // 如果已有缓存数据，直接使用
      if (cache.data) {
        this.updateVipPrices(cache.data)
        return
      }
      
      // 如果正在请求中，等待请求完成
      if (cache.loading && cache.promise) {
        cache.promise.then(data => {
          if (data) {
            this.updateVipPrices(data)
          }
          // 如果失败，data 为 null，保持原有价格不变
        }).catch(() => {
          // 请求失败，保持原有价格不变
        })
        return
      }
      
      // 发起新请求
      cache.loading = true
      cache.promise = getUserTypeList('student').then(res => {
        cache.loading = false
        if (res.code === '0000' && res.data && res.data.length > 0) {
          cache.data = res.data
          this.updateVipPrices(res.data)
          return res.data
        } else {
          // 接口返回错误，保持原有价格不变
          return null
        }
      }).catch(err => {
        cache.loading = false
        cache.promise = null
        // 请求失败，保持原有价格不变，不更新数据
        console.error('获取会员价格失败，使用默认价格:', err)
        return null
      })
    },
    // 更新会员价格
    updateVipPrices(data) {
      if (!data || !Array.isArray(data)) return
      
      data.forEach(item => {
        const config = this.vipConfigs.find(vip => {
          // 根据 typeName 匹配
          if (item.typeName === '月会员' && vip.type === 4) return true
          if (item.typeName === '季度会员' && vip.type === 7) return true
          if (item.typeName === 'PLUS年会员' && vip.type === 5) return true
          if (item.typeName === '尊享永久会员' && vip.type === 1) return true
          return false
        })
        
        if (config) {
          // 更新价格信息
          config.price = item.price.toString()
          
          // 根据 durationUnit 生成单位
          let unit = ''
          if (item.durationUnit === 'month') {
            unit = item.durationValue === 1 ? '元/月' : `元/${item.durationValue}月`
          } else if (item.durationUnit === 'year') {
            unit = item.durationValue === 1 ? '元/年' : `元/${item.durationValue}年`
          } else if (item.durationUnit === 'day') {
            unit = item.durationValue === 1 ? '元/天' : `元/${item.durationValue}天`
          } else {
            unit = config.unit // 保持原有单位
          }
          config.unit = unit
          
          // 更新原价（如果存在）
          if (item.originalPrice) {
            config.originalPrice = `${item.originalPrice}${unit}`
          }
          
          // 更新每日限制
          if (item.dailyFreeTimes) {
            config.dailyLimit = `${item.dailyFreeTimes}次/天/账号`
          }
        }
      })
    },
    getVip(vipType) {
      debugger
      let param = {
        userId: Number(this.userId),
        userVipType: vipType.toString(),
      }
      openVip(param).then(res => {
        if (res.code === "0000") {
          const div = document.createElement('div');
          /* 此处form就是后台返回接收到的数据 */
          div.innerHTML = res.data;
          document.body.appendChild(div);

          // 2. 移除表单自带的自动提交脚本（关键：避免提前提交）
          const scripts = div.querySelectorAll('script');
          scripts.forEach(script => script.remove());

          // 3. 等待Vue DOM更新完成后再操作（比setTimeout更可靠）
          this.$nextTick(() => {
            // 4. 明确获取表单（优先用ID，避免索引问题）
            const form = div.querySelector('form[name="punchout_form"]') || document.forms[0];
            if (form) {
              // 强制设置属性（覆盖默认值）
              form.target = '_blank'; // 确保新窗口打开
              form.acceptCharset = 'utf-8';
              // 手动提交
              form.submit();

              // 5. 提交后清理临时DOM（避免残留）
              setTimeout(() => {
                document.body.removeChild(div);
              }, 500);
            }
          });

        }

      })
    },
  }
}
</script>
<style>
.bottom-box .box_item {
  line-height: 30px;
  font-size: 0;
  color: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.box_item > .item_txt {
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box_item > .item_select,
.box_item .icon-right {
  flex-shrink: 0;
  text-align: right;
  font-weight: normal;
  white-space: nowrap;
  margin-left: 8px;
}

</style>
<style lang="scss" scoped>

* {
  margin: 0;
  padding: 0;
}

.member-vip-list {
  display: flex;
  margin-top: 40px;

  .member-vip {
    width: 282px;
    background-color: #fff;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    flex: none;
    border-radius: 12px;
    margin-right: 0;
    position: relative;
    transition: all 0.3s ease;

    .recommend-tag {
      position: absolute;
      top: 0;
      right: 0;
      background: linear-gradient(135deg, #ff6b00, #ff9500);
      color: #fff;
      font-size: 12px;
      font-weight: 600;
      padding: 4px 12px;
      border-radius: 0 12px 0 12px;
      z-index: 10;
      box-shadow: 0 2px 8px rgba(255, 107, 0, 0.3);
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    }

    .top-box {
      width: 100%;
      box-sizing: border-box;
      padding: 28px 14px 24px;
      text-align: center;
      border-radius: 12px 12px 0 0;
      background: linear-gradient(180deg, #fffbf5 0%, #fff5eb 100%);

      h4 {
        font-family: PingFangSC-Semibold, Microsoft YaHei, Arial, Helvetica, sans-serif;
        margin: 0 0 20px 0;
        font-size: 20px;
        line-height: 1;
        font-weight: 600;
        color: #994b00;
      }

      .member-vip-panel {
        font-family: PingFangSC-Regular, Microsoft YaHei, Arial, Helvetica, sans-serif;
        width: 100%;
        text-align: center;

        strong {
          display: block;
          margin-bottom: 10px;
        }

        .price-box {
          margin-left: 0;
        }

        .price {
          color: #cc5500;
          font-size: 42px;
          font-weight: 700;
          line-height: 1.2;
        }

        .price-unit {
          color: #994b00;
          font-size: 14px;
          font-weight: 500;
        }

        .original-price {
          color: #999;
          font-size: 12px;
          text-decoration: line-through;
          margin-left: 6px;
        }

        .price-shift-left {
          margin-left: 0;
        }

        .desc {
          font-size: 12px;
          color: #666;
          margin: 14px 0 20px;
          line-height: 1.4;
          white-space: nowrap;
        }

        .upgrade-btn {
          background: #2877ff;
          color: white;
          width: 90%;
          max-width: 220px;
          height: 42px;
          font-size: 15px;
          font-family: PingFangSC-Semibold, Microsoft YaHei, Arial, Helvetica, sans-serif;
          font-weight: 600;
          line-height: 42px;
          cursor: pointer;
          border-radius: 21px;
          border: 0;
          outline: 0;
          transition: background 0.3s;

          &:hover {
            background: #1a66e5;
          }
        }
      }
    }


    .bottom-box {
      box-sizing: border-box;
      padding: 20px;
      background: #fff;

      div > h5 {
        height: auto;
        margin-bottom: 14px;
        font-size: 14px;
        font-weight: 600;
        color: #994b00;
        display: flex;
        align-items: center;
        margin-block-start: 14px;
        margin-inline-start: 0;
        margin-inline-end: 0;

        img {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
      }

      div > h5 > i {
        display: inline-block;
        vertical-align: middle;
        margin-right: 6px;
        font-size: 14px;
      }

      .primary-color6 {
        color: #2877ff;
      }
    }

    .bottom-box .box_item > .item_txt,
    .bottom-box .box_item > b {
      display: inline-block;
      vertical-align: middle;
      font-size: 13px;
    }
  }
}

</style>
